import { render } from "./BillingDetails.vue?vue&type=template&id=28ababd4&scoped=true"
import script from "./BillingDetails.vue?vue&type=script&lang=js"
export * from "./BillingDetails.vue?vue&type=script&lang=js"

import "./BillingDetails.vue?vue&type=style&index=0&id=28ababd4&lang=scss&scoped=true"

import exportComponent from "/Users/chrismains/Sites/fixmycar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28ababd4"]])

export default __exports__